import LogIn from './LogIn';

export default LogIn;